import { FaVial } from "react-icons/fa";
import CardNotificacaoBase from "./CardNotificacaoBase";

const CardExame = ({ notif }) => {
    const info = notif.atendimento_info || {};

    let dataFormatada = info.data_criacao || "";
    if (dataFormatada && !dataFormatada.includes('/')) {
        try {
            dataFormatada = new Date(dataFormatada).toLocaleString("pt-BR");
        } catch (e) {}
    }

    const handleClick = () => {
        if (info.uuid) {
            window.location.href = `/atendimentos/edit/${info.uuid}/?tab=exames`;
        } else if (info.id) {
            window.location.href = `/atendimentos/edit/${info.id}/?tab=exames`;
        }
    };

    return (
        <CardNotificacaoBase
            notificacao={notif}
            icon={<FaVial />}
            color="warning"
            text="text-warning"
            label="Exame Solicitado"
            titulo={
                <span>
                    Nova Solicitação de Exame | Paciente: <strong>{info.beneficiario_nome || 'N/A'}</strong>
                </span>
            }
            descricao={
                <div>
                   Programa: {info.programa_nome || 'N/A'}
                </div>
            }
            dataFormatada={dataFormatada}
            onClick={handleClick}
        />
    );
};

export default CardExame;
